import { render, staticRenderFns } from "./mainWallet.vue?vue&type=template&id=90768300&"
import script from "./mainWallet.vue?vue&type=script&lang=js&"
export * from "./mainWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports